import { useLazyQuery } from '@apollo/client'
import { graphql } from '../__generated__'

const query = graphql(`
  query GetShortLinkByReportSourceId(
    $reportSourceId: PublicReportSourceGlobalId!
    $institutionId: UUID!
  ) {
    publicReportSource(
      reportSourceId: $reportSourceId
      institutionId: $institutionId
    ) {
      id
      shortLink
    }
  }
`)

export const useGetShortLinkByReportSourceId = () => {
  const [fetch] = useLazyQuery(query)
  return {
    getShortLinkByReportSourceId: async (id: string, institutionId: string) => {
      const { data } = await fetch({
        variables: {
          reportSourceId: id,
          institutionId,
        },
      })
      return data?.publicReportSource?.shortLink
    },
  }
}
